module.exports = __webpack_public_path__ + "img/android6.72d9222f.jpg";